"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubTitle = void 0;

var react_1 = __importDefault(require("react"));

var elements_1 = require("../../elements");

var SubTitle = function SubTitle(_a) {
  var title = _a.title,
      leadText = _a.leadText,
      theme = _a.theme,
      elementId = _a.elementId;
  return react_1["default"].createElement("div", {
    className: "pt-4 pb-2 md:pt-4 md:pb-4 lg:pt-6 xl:pt-8 xl:pb-6",
    id: elementId
  }, react_1["default"].createElement(elements_1.TitleSub, {
    theme: theme
  }, title), react_1["default"].createElement(elements_1.Hruler, {
    theme: theme
  }), leadText && react_1["default"].createElement(elements_1.TextLead, {
    theme: theme
  }, leadText));
};

exports.SubTitle = SubTitle;